// extracted by mini-css-extract-plugin
module.exports = {"accordion":"__accordion__zUAe1","closeIconClass":"__closeIconClass__f9cQA"};